"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyNotReadableError = void 0;
// Re-Export of default export is not possible, so we MUST export it named
// eslint-disable-next-line import/prefer-default-export
var ApiKeyNotReadableError = /** @class */ (function (_super) {
    __extends(ApiKeyNotReadableError, _super);
    function ApiKeyNotReadableError() {
        var _this = _super.call(this, 'No token available') || this;
        Object.setPrototypeOf(_this, ApiKeyNotReadableError.prototype);
        return _this;
    }
    return ApiKeyNotReadableError;
}(Error));
exports.ApiKeyNotReadableError = ApiKeyNotReadableError;
//# sourceMappingURL=ApiKeyNotReadableError.js.map